module.exports = __webpack_public_path__ + "img/NarminOsman.b308451c.jpg";